const getters = {
  all: state => state.all,
  allAmount: state => amount => Number((amount/state.percentAgency).toFixed(2)),
  amountAgency: (state, getters) => amount => Number((getters.allAmount(amount) - amount).toFixed(2)),
  getStatus: state => invoice => {
    if(Number(Number(invoice.total_charge) - Number(invoice.total_payment)) === 0){
      return state.statuses.payed
    }
    else if(Number(invoice.total_payment) === 0){
      return state.statuses.noPayed
    }
    else{
      return state.statuses.payedPart
    }
  }
};

export default getters;